export const ITEMS_PER_PAGE = 10;

export const QUALITY_COMMENT_STATUS_FILTERS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  ALL: 'all',
};

export const INITIAL_COMMENT_STATE = {
  uuid_project: '',
  uuid_task: '',
  task_name: '',
  observations: '',
  control_date: '',
  status: '',
  updated_at: '',
  uuid_allotment: '',
  uuid_lot: '',
  lot_number: '',
  block_number: '',
  allotment_name: '',
};
